import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'class-names';

const AnimationTransition = ({ children, startClassName, endClassName, applyTransition, delayMs, isEnabled }) => {
  const [applyClass, setClass] = useState();

  useEffect(() => {
    setTimeout(() => {
      if (isEnabled === undefined || isEnabled) {
        setClass(endClassName);
      } else {
        setClass();
      }
    }, delayMs);
  }, [delayMs, isEnabled]);

  return (
    <div className={cn(startClassName, applyClass)} style={{ transition: applyTransition } || {}}>
      {children}
    </div>
  );
};

AnimationTransition.propTypes = {
  children: PropTypes.node.isRequired,
  startClassName: PropTypes.string,
  endClassName: PropTypes.string,
  applyTransition: PropTypes.string.isRequired,
  delayMs: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEnabled: PropTypes.bool,
};

AnimationTransition.defaultProps = {
  startClassName: undefined,
  endClassName: undefined,
  delayMs: 0,
  isEnabled: true,
};

export default AnimationTransition;
